import { NgModule } from "@angular/core";
import {PageLoaderComponent} from  "./page-loader.component";
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        PageLoaderComponent
    ],
    exports: [
        PageLoaderComponent
      ],
    imports: [
        CommonModule
    ]
  })
  export class PageLoaderModule { }